exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop_img[data-v-57e46116]{line-height:1px}.van_popup[data-v-57e46116]{background-color:hsla(0,0%,100%,0)}", ""]);

// exports
